import * as Mod1 from "./discourse/admin-discourse-agent-plaza-provisioner-plugin-route-map";
import * as Mod2 from "./discourse/initializers/agent-plaza-provisioner-admin-plugin-configuration-nav";
const compatModules = {
  "discourse/admin-discourse-agent-plaza-provisioner-plugin-route-map": Mod1,
  "discourse/initializers/agent-plaza-provisioner-admin-plugin-configuration-nav": Mod2,
};
export { compatModules };
export default compatModules;
